import React, { useMemo } from 'react';

import StickyPageHeader from '../components/common/StickyPageHeader';
import FuelSurchargeTable from '../components/tables/FuelSurchargeTable';
import {
  useCarriers,
  useFuelSurchargeUpdate,
  useUserPermission,
} from '../hooks/apiHooks';
import Layout from '../layout';

const FuelSurchargePage = ({ disableLayout, routes }) => {
  const userHasPermission = useUserPermission();
  const { allCarriers, isLoading: isCarriersLoading } = useCarriers();
  const updateMutation = useFuelSurchargeUpdate();

  const editableCarriers = useMemo(
    () =>
      allCarriers
        .filter((carrier) => userHasPermission(carrier, 'optionPermission'))
        .slice()
        .sort((a, b) => (a.name || '').localeCompare(b.name || '')),
    [allCarriers, userHasPermission]
  );

  const savingCarrierId =
    updateMutation.isLoading &&
    updateMutation.variables &&
    !Array.isArray(updateMutation.variables)
      ? updateMutation.variables.carrierId
      : undefined;

  const content = (
    <>
      <StickyPageHeader isAdmin title="Fuel Surcharges" />
      <FuelSurchargeTable
        loading={isCarriersLoading}
        rows={editableCarriers}
        savingCarrierId={savingCarrierId}
        onBulkSave={updateMutation.mutateAsync}
        onSave={updateMutation.mutateAsync}
      />
    </>
  );

  if (disableLayout) return content;

  return (
    <Layout
      disableLoading
      skipFullPageLoader
      menuIndex={0}
      routes={routes}
      showCarriersNavigation={false}
    >
      {content}
    </Layout>
  );
};

export default FuelSurchargePage;
